import { render } from "./AdvancedTeamActionsOverview.vue?vue&type=template&id=58c96522"
import script from "./AdvancedTeamActionsOverview.vue?vue&type=script&lang=js"
export * from "./AdvancedTeamActionsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__